<template>
  <ResultPage v-if="result" :result="result" />
  <div v-else class="loading-screen">
    <div class="spinner" />
  </div>
</template>

<script>
import ResultPage from '../components/ResultPage.vue'
import { quizStore } from '../store/quiz'

export default {
  name: 'QuizResultView',
  components: { ResultPage },
  props: { id: { type: [String, Number], required: true } },
  computed: {
    result () { return quizStore.getState().result }
  },
  created () {
    if (!this.result || String(quizStore.getState().quizId) !== String(this.id)) {
      this.$router.replace({ name: 'QuizLanding', params: { id: this.id } })
    }
  }
}
</script>
